<div class="card-deck mb-4">
  <jhi-bary-card>
    <div body>
      <div class="timeline-main">
        <!-- Timeline Wrapper -->
        <ul *ngIf="transportOrder && trackAndTraceItems" class="stepper stepper-vertical timeline timeline-basic">
          <li *ngFor="let trackAndTraceItem of trackAndTraceItems; let isOdd = odd" [class.timeline-inverted]="isOdd">
            <jhi-track-and-trace-item [trackAndTraceItem]="trackAndTraceItem" [savMail]="savMail" [companyName]="transporter.companyName!"></jhi-track-and-trace-item>
          </li>
        </ul>
        <!-- Timeline Wrapper -->
      </div>
    </div>
  </jhi-bary-card>
</div>
